import { Row, Col, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useUserStore } from "../../store/user-store";
import { useDataFetch } from "../../hooks/use-data-fetch";
import { API_BASE_URL } from "../../config";

import CustomerVisit from "../../components/Dashboard/Store/CustomerVisit";
import Welcome from "../../components/Dashboard/Store/Welcome";
import ProductsGridContent from "../../components/eCommerce/Products";
import { getUserCompletionStatus } from "../../utils/getUserCompletionStatus";

const Store = () => {
  const user = useUserStore((state) => state.user);

  const { getData } = useDataFetch();
  const { data: bannerResponse } = getData(
    ["global-banner"],
    "/product/get/banner"
  );

  const [showBannerModal, setShowBannerModal] = useState(false);
  const [bannerImage, setBannerImage] = useState<string | null>(null);

  const completion = getUserCompletionStatus(user || {});
  const isBlocked = !completion?.summary?.isComplete;

  useEffect(() => {
    if (!user || !bannerResponse) return;

    const alreadyShown = sessionStorage.getItem("bannerShown");

    if (
      bannerResponse?.banner?.status &&
      bannerResponse?.banner?.image &&
      !alreadyShown
    ) {
      setBannerImage(bannerResponse.banner.image);
      setShowBannerModal(true);
    }
  }, [bannerResponse, user]);

  useEffect(() => {
    if (showBannerModal) {
      sessionStorage.setItem("bannerShown", "true");
    }
  }, [showBannerModal]);

  return (
    <>

      <Row>
        <Col lg={!isBlocked ? 9 : 12}>
          <Welcome isBlocked={isBlocked} />
          <ProductsGridContent />
        </Col>
        {!isBlocked && (
          <Col lg={3}>
            <CustomerVisit />
          </Col>
        )}
      </Row>

      <Modal
        show={showBannerModal}
        onHide={() => setShowBannerModal(false)}
        centered
        size="lg"
        backdrop="static"
      >
        <Modal.Body
          style={{
            padding: 0,
            backgroundColor: "transparent",
            border: "none",
            textAlign: "center",
            position: "relative"
          }}
        >
          {bannerImage && (
            <img
              src={`${API_BASE_URL}/product/get-file-banner/${bannerImage}`}
              alt="Banner Promocional"
              style={{
                width: "100%",
                maxHeight: "80vh",
                objectFit: "contain",
                borderRadius: "12px"
              }}
            />
          )}

          <button
            onClick={() => setShowBannerModal(false)}
            style={{
              position: "absolute",
              top: 15,
              right: 15,
              background: "rgba(0,0,0,0.7)",
              border: "none",
              color: "#fff",
              borderRadius: "50%",
              width: 40,
              height: 40,
              cursor: "pointer",
              fontSize: 18
            }}
          >
            ×
          </button>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Store;